<!-- Footer content will be added here by the user -->
<div class="footer-container">
    <div class="footer-content">

        <img src="images/sponsor/logo_senior_minuni.png" alt="SeniorScreen" class="img-fluid me-3"
            style="max-height: 40px;">
        <img src="images/sponsor/logo_senior_italiadomani.png" alt="SeniorScreen" class="img-fluid me-3"
            style="max-height: 40px;">
        <img src="images/sponsor/logo_senior_pnc.png" alt="SeniorScreen" class="img-fluid me-3"
            style="max-height: 40px;">
        <img src="images/sponsor/logo_senior_dare.png" alt="SeniorScreen" class="img-fluid me-3"
            style="max-height: 40px;">
        <img src="images/sponsor/logo_senior_torvergata.png" alt="SeniorScreen" class="img-fluid me-3"
            style="max-height: 40px;">
            <img src="images/sponsor/logo_senior_hlt.png" alt="SeniorScreen" class="img-fluid"
            style="max-height: 20px;">

        <p class="text-center text-muted small mt-2 mb-0">
            &copy; 2026 SeniorScreen
        </p>

    </div>
</div>